import React, { useMemo } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';
import { useLocation } from 'react-router-dom';
import { PERMISSIONS } from 'constants/permissions';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.deals.purchaseRequest,
        label: 'Purchase Request',
        permission: PERMISSIONS.deals.tabs.purchaseRequest.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.deals.commercialOffers,
        label: 'Commercial Offers',
        permission: PERMISSIONS.deals.tabs.commercialOffers.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.deals.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.deals.tabs.communicationHub.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.deals.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.deals.tabs.task.read,
        id: '4',
      },
      {
        path: ADMIN_ROUTES.deals.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.deals.tabs.attachment.read,
        id: '5',
      },
      {
        path: ADMIN_ROUTES.deals.logs,
        label: 'Logs',
        permission: PERMISSIONS.deals.tabs.logs.read,
        id: '6',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
